export const state = () => ({
  groupDataTemp: {}
})

export const mutations = {
  SET_GROUP_DATA_TEMP: (state, value) => {
    state.groupDataTemp = value
  }
}

export const actions = {
  setGroupDataTemp (context, payload) {
    context.commit('SET_GROUP_DATA_TEMP', payload)
  }
}
